import React from 'react';
import { Box, Typography } from '@mui/material';

const FormSettingRow = ({ title, description, children, dimmed = false }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 3,
      py: 0.5,
    }}
  >
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: '0.875rem',
          color: dimmed ? 'text.disabled' : 'text.primary',
          mb: 0.5,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: '0.8125rem',
          color: dimmed ? 'text.disabled' : 'text.secondary',
          lineHeight: 1.45,
        }}
      >
        {description}
      </Typography>
    </Box>
    <Box sx={{ flexShrink: 0, pt: 0.25 }}>{children}</Box>
  </Box>
);

export default FormSettingRow;
